import script from "./doctorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorInfo.vue?vue&type=script&setup=true&lang=js"

import "./doctorInfo.vue?vue&type=style&index=0&id=2ae8feb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ae8feb8"]])

export default __exports__